import "./navbar.css";
import { Link } from "react-router-dom";
import VirtualLogo from "../../assets/logo/virtualLogo-01.png";
import { NavLink } from "react-router-dom";
import { useEffect } from "react";

function NavbaaComp() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);
  return (
    <div className="navbar-bg">
      <div className="container">
        <div className=" row justify-content-center">
          <nav className="navbar navbar-expand-lg fixed-top  ">
            <div className="container mt-2 mb-2">
              <a className="navbar-brand">
                <Link to="/">
                  <img
                    src={VirtualLogo}
                    className="img-fluid"
                    width={"70px"}
                    alt=""
                  />
                </Link>
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav m-auto gap-4">
                  <li className="nav-item ">
                    <NavLink
                      to="/"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                        
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Home
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item ">
                    <NavLink
                      to="/web3"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Web3
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/metaverse"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Metaverse
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/app"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        App
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/software"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Software
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/ai"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Ai
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/iot"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Iot
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/chatbot"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Chatbot
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/portfolio"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Portfolio
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/aboutus"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        About Us
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/contactus"
                      className={(NavData) =>
                        NavData.isActive ? "active" : "link"
                      }
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                      >
                        Contact Us
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default NavbaaComp;
